import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import {
	GET_ACCOUNT_STATEMENTS_BY_CLIENT_ID,
	GET_ANTICIPOS_BY_PERIOD_AND_CLIENT_ID,
} from '../graphql/account-statements.queries';

@Injectable({
	providedIn: 'root',
})
export class AccountStatementsService {
	constructor(private graphService: GraphService) {}

	getByClientId(clientId: String): Observable<any> {
		return this.graphService.queryGraphQL<any>({
			query: GET_ACCOUNT_STATEMENTS_BY_CLIENT_ID,
			variables: { clientId },
		});
	}

	getAnticipos(clientId: String, period: String): Observable<any> {
		return this.graphService.queryGraphQL<any>({
			query: GET_ANTICIPOS_BY_PERIOD_AND_CLIENT_ID,
			variables: { clientId, period },
		});
	}
}
